export default __webpack_public_path__ + "static/media/close.59fce1e8.svg";